// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { createQuote, deleteQuote, getAllQuotes, getQuote, quoteToPdf, updateQuote } from '../../helpers/backend_helper';
import { createQuoteFailure, createQuoteSuccess, fetchQuotesFailure, fetchQuotesSuccess, quoteToPdfFailure, quoteToPdfRequest, quoteToPdfSuccess, updateQuoteFailure, updateQuoteSuccess } from './actions';
import { deleteQuoteFailure, deleteQuoteSuccess, fetchQuoteFailure, fetchQuoteSuccess } from '../actions';
import { CREATE_QUOTE_REQUEST, DELETE_QUOTES_REQUEST, FETCH_QUOTES_REQUEST, FETCH_QUOTE_REQUEST, QUOTE_TO_PDF_REQUEST, UPDATE_QUOTES_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchQuotesSaga() {
  try {
    const response = yield call(getAllQuotes);

    // Store the mapping in localStorage
    yield put(fetchQuotesSuccess(response.data));
  } catch (error) {
    yield put(fetchQuotesFailure(reduxSerializedError(error)));
  }
}

function* fetchQuoteSaga({ payload }) {
  try {
    const response = yield call(getQuote, payload);
    yield put(fetchQuoteSuccess(response));
  } catch (error) {
    yield put(fetchQuoteFailure(reduxSerializedError(error)));
  }
}

function* deleteQuotesSaga({ payload }) {
  try {
    yield call(deleteQuote, payload);
    yield put(deleteQuoteSuccess(payload));
    yield call(fetchQuotesSaga);
  } catch (error) {
    yield put(deleteQuoteFailure(reduxSerializedError(error)));
  }
}

function* updateQuoteSaga({ payload }) {
  const { project } = payload;
  try {
    yield call(updateQuote, project);
    yield put(updateQuoteSuccess());
    yield call(fetchQuotesSaga); 
  } catch (error) {
    yield put(updateQuoteFailure(reduxSerializedError(error)));
  }
}

function* createQuoteSaga({ payload }) {
  const { configId, imageName } = payload;
  try {
    const response = yield call(createQuote, configId);
    if (response) {
      yield put(createQuoteSuccess(response));
      yield put(quoteToPdfRequest(payload));
    }
  } catch (error) {
    yield put(createQuoteFailure(reduxSerializedError(error)));
  }
}

function* quoteToPdfSaga({ payload }) {
  try {
    const response = yield call(quoteToPdf, payload);
    if (response) {
      yield put(quoteToPdfSuccess(response.data));
    }
  } catch (error) {
    yield put(quoteToPdfFailure(reduxSerializedError(error)));
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_QUOTES_REQUEST, fetchQuotesSaga);
  yield takeEvery(FETCH_QUOTE_REQUEST, fetchQuoteSaga);
  yield takeEvery(UPDATE_QUOTES_REQUEST, updateQuoteSaga);
  yield takeEvery(DELETE_QUOTES_REQUEST, deleteQuotesSaga);
  yield takeEvery(CREATE_QUOTE_REQUEST, createQuoteSaga);
  yield takeEvery(QUOTE_TO_PDF_REQUEST, quoteToPdfSaga);
}
